var map = {
	"../../pages/overview/overview.module": [
		"./src/app/pages/overview/overview.module.ts",
		"default~layout-header-header-module~pages-login-login-module~pages-overview-overview-module~pages-re~9515de28",
		"default~pages-overview-overview-module~pages-sick-note-sick-note-module",
		"common",
		"pages-overview-overview-module"
	],
	"../../pages/sick-note/sick-note.module": [
		"./src/app/pages/sick-note/sick-note.module.ts",
		"default~layout-header-header-module~pages-login-login-module~pages-overview-overview-module~pages-re~9515de28",
		"default~pages-overview-overview-module~pages-sick-note-sick-note-module",
		"common",
		"pages-sick-note-sick-note-module"
	],
	"./layout/header/header.module": [
		"./src/app/layout/header/header.module.ts",
		"default~layout-header-header-module~pages-login-login-module~pages-overview-overview-module~pages-re~9515de28",
		"common",
		"layout-header-header-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"default~layout-header-header-module~pages-login-login-module~pages-overview-overview-module~pages-re~9515de28",
		"common",
		"pages-login-login-module"
	],
	"./pages/registration/registration.module": [
		"./src/app/pages/registration/registration.module.ts",
		"default~layout-header-header-module~pages-login-login-module~pages-overview-overview-module~pages-re~9515de28",
		"common",
		"pages-registration-registration-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;